import React from 'react';
import { ThoughtFeed } from './components/ThoughtFeed';

export const App = () => {
  return (
    <ThoughtFeed />
  );
}
